import { Avatar as MuiAvatar, AvatarProps as MuiAvatarProps, lighten } from '@mui/material'

import Colors from '#/styles/Colors'
import Fonts from '#/styles/Fonts'

type AvatarSize = 'small' | 'medium' | 'large'

export type AvatarProps = Omit<MuiAvatarProps, 'color'> & {
  /** Cor do conteúdo, aplicada também clareada ao fundo */
  color?: string
  size?: AvatarSize
}

const SIZES: Record<AvatarSize, { dimension: number; fontSize: number }> = {
  large: { dimension: 56, fontSize: Fonts.fontSize.L },
  medium: { dimension: 48, fontSize: Fonts.fontSize.M },
  small: { dimension: 32, fontSize: Fonts.fontSize.SS },
}

export default function Avatar({
  color = Colors.primary,
  size = 'medium',
  sx,
  variant = 'rounded',
  ...rest
}: AvatarProps) {
  const { dimension, fontSize } = SIZES[size]

  return (
    <MuiAvatar
      {...rest}
      variant={variant}
      sx={{
        background: lighten(color, 0.85),
        color,
        fontSize,
        fontWeight: Fonts.fontWeight.bold,
        height: dimension,
        width: dimension,
        ...sx,
      }}
    />
  )
}
